import React, { useContext, useEffect, useState } from 'react';
import Select from '../../inputs/select';
import Blocks from '../../newcalendar/Blocks';
import useCountry from '../../../hooks/countryHook';
import CalendarMobile from '../../newcalendar/CalendarMobile';
import ServiceContext from '../../../contexts/serviceContext';
import { getProfessionalsByService } from '../../../api';
import './style.scss';

const defErrors = {
  professional: false,
  calendar: false,
  blocks: false,
};

const ScheduleModal = (props) => {
  const { t } = useCountry();
  const { show, toggleShow, history, filters, service, isReschedule = false, serviceFormulary, appointmentId = '', token = '' } = props;
  const { sku, type, store, subLocation, local, professional } = filters;
  const { checkoutInformation, setCheckoutInformation } = useContext(ServiceContext);
  const isMobile = window.innerWidth <= 767;
  const [isLoading, setIsLoading] = useState(true);
  const [needCheckAProfessional, setNeedCheckAProfessional] = useState(true);
  const [professionals, setProfessionals] = useState([]);
  const [selectedProfessional, setSelectedProfessional] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState({});
  const [availabilityInfo, setAvailabilityInfo] = useState({});
  const [serviceDailyDisplayHours, setServiceDailyDisplayHours] = useState(null);
  const [formErrors, setFormErrors] = useState(defErrors);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    if(professionals.length > 0 || subLocation.length > 0) {
      setVisible(true);
    }
  }, [store,subLocation,local,professionals]);

  useEffect(() => {
    const getProfessionals = async () => {
      const data = await getProfessionalsByService(sku, type, store, subLocation, local);

      if (data && 'respCode' in data && data.respCode === 200 && data.data.length) {
        setNeedCheckAProfessional(true);
        parseProfessionalList(data.data);
      } else {
        setNeedCheckAProfessional(false);
      }
      setIsLoading(false);
    };

    if (show) {
      getProfessionals();
    }
  }, [show, sku, type, store, subLocation, local]);

  const parseProfessionalList = (values) => {
    setProfessionals(
      values.map((v) => ({
        value: v.userId,
        text: `${v.professionalName} ${v.professionalLastName}`,
      }))
    );
  };



  if (!show) {
    return null;
  }

  return (
    <div className='service-calendar-modal service-calendar-modal-mobile'>
      <div className='service-calendar-container'>
        <div className='service-calendar-top'>
          <span>{isMobile ? t('plp.schedule-modal.mobile-title') : t('plp.schedule-modal.desktop-title')}</span>
        </div>
        <div className="modal-container">
          <div className="availability-box">
            <h3 className="availability-title">Selecciona para consultar disponibilidad en tu zona</h3>
            <ul className="availability-list">
              <li>El listado incluye únicamente las regiones disponibles para este servicio.</li>
            </ul>
          </div>

          <div className={'modal-step__content modal-step'}>
            {props.children}
          </div>
          <div
            className={`modal-step ${isMobile ? 'modal-step--bordered' : ''}`}
            style={{ paddingTop: 0 }}
          >
            <div className={`${
              !needCheckAProfessional || isLoading ? 'modal-step--hide' : ''
            } modal-step__content`}>
              <Select
                label={t('plp.schedule-modal.professional-label')}
                items={professionals}
                placeHolder={t('plp.schedule-modal.professional-placeholder')}
                onSelect={setSelectedProfessional}
                id="selprofesionaltitle"
                errorMessage={t('plp.schedule-modal.professional-error')}
                displayError={formErrors.professional}
                defaultSelected={professional}
              />
            </div>

            <div className={`modal-fixed-steps ${
              !isVisible ? 'calendar-hide' : ''
            }`}>

              <div className={`modal-step__calendar ${isMobile ? 'modal-step--bordered' : ''}`}>
              <span
                className={`modal-step__title ${
                  needCheckAProfessional && Object.keys(selectedProfessional).length === 0
                    ? 'modal-step__title--disabled'
                    : ''
                }`}
              >
              </span>

                <div className={`modal-step__content ${isMobile ? 'modal-step__content--fw' : ''}`}>
                  <CalendarMobile
                    filters={filters}
                    professional={selectedProfessional}
                    history={history}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    setAvailabilityInfo={setAvailabilityInfo}
                    setServiceDailyDisplayHours={setServiceDailyDisplayHours}
                    maydayIntegrationIsActive={service?.maydayIntegrationIsActive || false}
                    readyToSearch={!needCheckAProfessional || !!selectedProfessional}
                    displayError={formErrors.calendar}
                    errorMessage={isMobile ? t('plp.schedule-modal.mobile-date-error') : t('plp.schedule-modal.desktop-date-error')}
                  />
                </div>
              </div>

              <div className="modal-step modal-step__blocks modal-step--without-border" id="modal-step__blocks">
              <span
                className={`modal-step__title modal-step__title--mobile ${
                  Object.keys(availabilityInfo).length === 0 || availabilityInfo?.availabilityBlocks.length === 0
                    ? 'modal-step__title--disabled'
                    : ''
                }`}
              >
                {t('plp.schedule-modal.block-title')}
              </span>

                <div className="modal-step__content modal-step__content--mh-410">
                  <Blocks
                    selectedDate={selectedDate}
                    availabilityInfo={availabilityInfo}
                    setSelectedBlock={setSelectedBlock}
                    displayError={formErrors.blocks}
                    dailyDisplayHours={serviceDailyDisplayHours}
                  />
                </div>
              </div>

            </div>

          </div>

        </div>
        <div className={'wrapper-note-box'}>
          <div className="note-box">
            <div className="note-content">
              <span className="note-title">Nota: </span>
              <span className="note-text">
      Recuerda que aquí solo puedes consultar la disponibilidad del servicio. Una vez finalizada la compra, recibirás un correo para agendar.
    </span>
          </div>
        </div>
        </div>
      </div>
      {<style>{`body { overflow: hidden; }`}</style>}
    </div>
  );
};

export default ScheduleModal;
